webpackJsonp([8418805283199],{

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ACTIVE_1992_2006.70fe5fef.jpg";

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ACTIVE_tabletennis_1987.f520d7c2.jpg";

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/AbbFAMILY2010.cfe2e533.gif";

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FAMILY_052004.a578384d.gif";

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Worker_01-1987+2011.37a86c97.jpg";

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/patient_dr_serie_12-1985.444ecf7a.jpg";

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/patient_serie_07-1998.8929a859.gif";

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/patient_wheelchair_09-1970.ab568e70.jpg";

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/unsichtbar_05-1972.54c102c3.jpg";

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImageGallery = __webpack_require__(27);
	
	var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);
	
	__webpack_require__(25);
	
	var _unsichtbar_ = __webpack_require__(500);
	
	var _unsichtbar_2 = _interopRequireDefault(_unsichtbar_);
	
	var _patient_wheelchair_ = __webpack_require__(499);
	
	var _patient_wheelchair_2 = _interopRequireDefault(_patient_wheelchair_);
	
	var _patient_dr_serie_ = __webpack_require__(497);
	
	var _patient_dr_serie_2 = _interopRequireDefault(_patient_dr_serie_);
	
	var _patient_serie_ = __webpack_require__(498);
	
	var _patient_serie_2 = _interopRequireDefault(_patient_serie_);
	
	var _ACTIVE_tabletennis_ = __webpack_require__(493);
	
	var _ACTIVE_tabletennis_2 = _interopRequireDefault(_ACTIVE_tabletennis_);
	
	var _ACTIVE_1992_ = __webpack_require__(492);
	
	var _ACTIVE_1992_2 = _interopRequireDefault(_ACTIVE_1992_);
	
	var _FAMILY_ = __webpack_require__(495);
	
	var _FAMILY_2 = _interopRequireDefault(_FAMILY_);
	
	var _AbbFAMILY = __webpack_require__(494);
	
	var _AbbFAMILY2 = _interopRequireDefault(_AbbFAMILY);
	
	var _Worker_ = __webpack_require__(496);
	
	var _Worker_2 = _interopRequireDefault(_Worker_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagineeringDisabilityPage = function ImagineeringDisabilityPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-5 project-info' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Imagineering Dis/Ability'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-content' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Images are not just simple copies, they are social practices which can inform us about cultural production of the category dis-/ability. A series of images over time can be read as indicators for social and cultural processes of change.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'According to Disability Studies \'dis-/ability\' is a socially constructed process and needs to be seen as a differential category like gender, race and class.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'An important part of how dis/abled bodies and people are perceived are prosthetics. Cultural technology research emphasises links between prosthetic technology, war, work and body optimisation utopias as well as experiences of destruction '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The empirical study analyses images of physical disabled people on the basis of promotional material from the world\u2019s leader of prosthetics and orthotics, Otto Bock. The research work is understood as the analysis of social conventions of normality and is situated in the cultural anthropological field of body politics research.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The analysed advertisement images from the 1950s until today articulate the change from exclusion and disregard (The Invisible Amputee), followed by the idea that disability is a malfunction (The Patient), followed by integration with the help of idealised utopia (The High-Performance Prosthetic User) towards an individualised human being with a lifestyle (The User with Lifestyle). Regarding prosthetic technology the research identifies the change from the idea that prosthetics are a replacement towards the idea of optimisation and value increase of the body.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Latest developments also show that with more advanced technology it becomes more difficult to determine the line of where the body ends and technology begins which brings up new ideas of normality and cultural shifts.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'A further analysis of the material will be provided upon request.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-7' },
	                _react2.default.createElement(_reactImageGallery2.default, {
	                    showThumbnails: false,
	                    showFullscreenButton: false,
	                    autoPlay: true,
	                    items: [{ original: _unsichtbar_2.default }, { original: _patient_wheelchair_2.default }, { original: _patient_dr_serie_2.default }, { original: _patient_serie_2.default }, { original: _ACTIVE_tabletennis_2.default }, { original: _ACTIVE_1992_2.default }, { original: _FAMILY_2.default }, { original: _AbbFAMILY2.default }, { original: _Worker_2.default }] }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'project-blurb' },
	                    'A cultural anthropological research about the perception of disability in correlation with prosthetic technology.'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'tags' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Disability Studies'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Cultural Technology Studies'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Visual Culture'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Visual Anthropology'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Body Politics'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Prosthetic Technology'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Abductive Reasoning'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Iconographical-Iconological Image-Discourse Analysis'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer-info' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Cooperation Partner:'
	                        ),
	                        ' WWU University M\xFCnster, Otto Bock Health Care'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Source:'
	                        ),
	                        'Otto Bock archive with more than 1000 different promotional images of a 60 years investigation period'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Date:'
	                        ),
	                        'December 2012 - October 2013'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = ImagineeringDisabilityPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-imagineering-dis-ability-js-7464c2bb7896ac794fea.js